import axios from 'axios';

import { AdditionalCapacity } from 'components/types';

import { ScenarioAdditionalCapacityType, Units } from '../../components/enums';

import { SCENARIO_ADDITIONAL_CAPACITY } from '../endpoints';

export interface SaveAdditionalCapacityPayload {
  description: string;
  quantity: number;
  hours: number;
  type: keyof typeof ScenarioAdditionalCapacityType;
  unit: keyof typeof Units;
  startDate: string;
  endDate: string;
  functionId?: number;
  organizationalUnitId: number;
}

export const getAdditionalCapacity = (scenarioId: number) =>
  axios.get<AdditionalCapacity[]>(SCENARIO_ADDITIONAL_CAPACITY, {
    pathParams: { scenarioId }
  });

export type SaveAdditionalCapacityOptions = {
  scenarioId: number;
  capacityId?: number;
  payload: SaveAdditionalCapacityPayload;
};

export const createAdditionalCapacity = ({
  payload,
  scenarioId
}: SaveAdditionalCapacityOptions) =>
  axios.post(SCENARIO_ADDITIONAL_CAPACITY, payload, {
    pathParams: { scenarioId }
  });

export const updateAdditionalCapacity = ({
  payload,
  scenarioId,
  capacityId
}: SaveAdditionalCapacityOptions) =>
  axios.put(`${SCENARIO_ADDITIONAL_CAPACITY}/${capacityId}`, payload, {
    pathParams: { scenarioId }
  });

export type DeleteAdditionalCapacityOptions = {
  id: number;
  scenarioId: number;
};

export const deleteAdditionalCapacity = ({
  id,
  scenarioId
}: DeleteAdditionalCapacityOptions) =>
  axios.delete(`${SCENARIO_ADDITIONAL_CAPACITY}/${id}`, {
    pathParams: { scenarioId }
  });
